<t4-header></t4-header>
<t4-periodPicker period="day" [(from)]="from" [(to)]="to" (periodChanged)="updateParams()"></t4-periodPicker>
<t4-container>
  <t4-data-table #tbl [rawData]="inspections" headline="" matSort [filterFields]="['Id','Alias', 'RentalLocation.Name', 'NextInspectionDate']" [autoGenerateColumns]="false">

    <ng-container matColumnDef="RegNo">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Regn No</mat-header-cell>
      <mat-cell *matCellDef="let row"> <mat-checkbox style="margin-right: 15px;" [checked]="row._selected" (change)="onRowSelected(row, $event.checked)"></mat-checkbox>{{ row.Alias || row.Title }}</mat-cell>
      <mat-footer-cell *matFooterCellDef style="font-weight: bold; background: #eee"></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="LocationName">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Location</mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.RentalLocation?.Name }}</mat-cell>
      <mat-footer-cell *matFooterCellDef style="font-weight: bold; background: #eee"></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="NextInspectionDate">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Next Inspection Date</mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.NextInspectionDate | date : 'yyyy-MM-dd' }}</mat-cell>
      <mat-footer-cell *matFooterCellDef style="font-weight: bold; background: #eee"></mat-footer-cell>
    </ng-container>

  </t4-data-table>
  <button mat-raised-button color="primary" (click)="createServiceRequests()" *ngIf="selectedCount > 0">
    <mat-icon>build</mat-icon>
    {{ 'Turbo.Maintenance.Inspections.Btn_CreateServiceRequest' | translate : 'Create service request' }}
  </button>
</t4-container>



